/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlogModule
 */
export interface BlogModule {
    /**
     * 
     * @type {boolean}
     * @memberof BlogModule
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BlogModule
     */
    wp_username?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogModule
     */
    wp_app_password?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogModule
     */
    wp_url?: string;
}

/**
 * Check if a given object implements the BlogModule interface.
 */
export function instanceOfBlogModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BlogModuleFromJSON(json: any): BlogModule {
    return BlogModuleFromJSONTyped(json, false);
}

export function BlogModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlogModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'wp_username': !exists(json, 'wp_username') ? undefined : json['wp_username'],
        'wp_app_password': !exists(json, 'wp_app_password') ? undefined : json['wp_app_password'],
        'wp_url': !exists(json, 'wp_url') ? undefined : json['wp_url'],
    };
}

export function BlogModuleToJSON(value?: BlogModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'wp_username': value.wp_username,
        'wp_app_password': value.wp_app_password,
        'wp_url': value.wp_url,
    };
}

